import homeRoute from './homeRoute'
import dashboardRoute from './dashboardRoute'
import defaultRoute from './defaultRoute'
import store from "@/store"

function loadView(view) {
    return () => import( /* webpackChunkName: "view-[request]" */ `@/views/${view}.vue`)
}
const routerFilter = async () => {
    const dashboardChild = await dashboardRoute;
    const homeChild = await homeRoute;
    const isLoggedIn = store.getters['getisLoggedIn']
    const myrole = store.getters["auth/getRole"];
    const temp = [
      ...defaultRoute,        
      {
        path: '/dashboard',
        meta: {
          requiresAuth: true,
          roleVerif: true,
          role: ['superamdin','bkak','kprhn','crew','prhn']
        },
        component: loadView('Dashboard'),
        children: dashboardChild
      },     
      {
        path: '',
        meta: {
          requiresAuth: false,
          roleVerif: false,
          role: []
        },
        component: loadView('Home'),
        children: homeChild
      },
    ]
    return temp.filter((row) => {
      return (row.meta.requiresAuth == isLoggedIn && ((row.meta.roleVerif && row.meta.role.some(role => role == myrole) || !row.meta.roleVerif))) || !row.meta.requiresAuth
    })
}

export default routerFilter()